import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import dayjs from 'dayjs';
import { changeNameFormat, allCapitalize } from 'utils/Utils';

pdfMake.fonts = {
    'Times New Roman': {
        normal: `${process.env.REACT_APP_END_POINT}/fonts/times-new-roman.ttf`,
        bold: `${process.env.REACT_APP_END_POINT}/fonts/times-new-roman-bold.ttf`,
    }
}

// Function to preload images and track progress
async function preloadImages(imageUrls, onProgress) {
    const images = [];
    let loadedCount = 0;

    for (const url of imageUrls) {
        const image = await new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.crossOrigin = "anonymous";
            img.onload = () => {
                loadedCount++;
                if (onProgress) onProgress((loadedCount / imageUrls.length) * 100); // Update progress
                resolve(img);
            };
            img.onerror = () => resolve();
        });
        if (image) images.push(image);
    }

    return images;
}

// Function to convert preloaded images to base64
function convertImagesToBase64(images) {
    return images.map(img => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);
        return canvas.toDataURL('image/png'); // Convert to base64
    });
}

export const createPDF = async ({ profile, educationData, workExperienceData, certificateData, customSection, summaryData, financeTechologiesData }) => {
    const image64 = "<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t viewBox=\"0 0 425.197 425.197\" style=\"enable-background:new 0 0 425.197 425.197;\" xml:space=\"preserve\">\r\n<rect x=\"0\" style=\"fill:#FFD700;\" width=\"425.197\" height=\"425.197\"/>\r\n<ellipse style=\"fill:#F9B104;\" cx=\"213.02\" cy=\"365.117\" rx=\"150\" ry=\"17.448\"/>\r\n<g>\r\n\t<path style=\"fill:#F9BB8D;\" d=\"M160.774,169.199c-1.246-6.277-7.222-12.121-15.422-10.329c-8.191,1.797-8.221,9.438-6.975,15.722\r\n\t\tc0.07,0.325,4.101,17.302,6.472,20.871c2.367,3.578,5.805,10.366,11.568,8.432c3.812-1.279,6.056-8.068,6.958-12.968\r\n\t\tC164.276,186.025,160.774,169.199,160.774,169.199z\"/>\r\n\t<path style=\"fill:#F9BB8D;\" d=\"M265.1,168.944c1.247-6.278,7.221-12.121,15.421-10.328c8.199,1.794,9.002,9.66,7.76,15.935\r\n\t\tc-0.069,0.333-4.427,16.044-6.471,20.881c-1.682,3.983-6.261,10.997-12.212,8.544c-3.72-1.535-6.197-8.407-7.1-13.307\r\n\t\tC261.598,185.77,265.1,168.944,265.1,168.944z\"/>\r\n\t<path style=\"fill:#259DAB;\" d=\"M85.461,361.205h254.276c0,0-5.012-62.414-13.354-71.767c-8.346-9.353-71.91-30.263-71.91-30.263\r\n\t\tl-83.081-0.241c0,0-66.884,19.574-71.452,30.504C95.371,300.366,85.461,361.205,85.461,361.205z\"/>\r\n\t<path style=\"fill:#C5D2DB;\" d=\"M204.605,259.028l-33.212-0.095c0,0-66.884,19.574-71.452,30.504\r\n\t\tc-4.569,10.929-14.479,71.767-14.479,71.767h33.543c0,0,9.91-60.839,14.478-71.767C137.874,278.933,199.79,260.451,204.605,259.028\r\n\t\tz\"/>\r\n\t<path style=\"fill:#D99870;\" d=\"M180.38,254.849c0,0,20.945,17.175,32.693,17.175c11.745,0,32.685-17.175,32.685-17.175\r\n\t\ts-8.862-10.315-2.753-23.867c6.108-13.549-68.125-12.439-59.495,0C192.136,243.422,180.38,254.849,180.38,254.849z\"/>\r\n\t<path style=\"fill:#E5D7D8;\" d=\"M202.142,268.927c1.563-4.294,4.7-8.598,9.729-12.261c5.027-3.665,8.003-0.374,29.269-12.578\r\n\t\tc-0.584-3.723-0.348-8.198,1.865-13.107c6.108-13.549-68.125-12.439-59.495,0c8.626,12.44-3.13,23.867-3.13,23.867\r\n\t\tS191.544,263.983,202.142,268.927z\"/>\r\n\t<path style=\"fill:#C5D2DB;\" d=\"M176.247,253.633l-4.855,5.301c0,0,14.473,35.747,27.041,40.277\r\n\t\tc3.837,1.385,11.834-16.331,14.622-16.331c1.345,0,12.141,18.793,13.781,18.42c12.874-2.936,27.637-42.125,27.637-42.125\r\n\t\tl-5.442-4.128l-35.976,22.642L176.247,253.633z\"/>\r\n\t<path style=\"fill:#F9BB8D;\" d=\"M273.104,121.97c0-27.239-16.875-54.569-61.553-54.569c-44.678,0-60.9,29.907-60.9,57.149\r\n\t\tc0,1.43-0.138,75.5,8.538,92.508c8.674,17.004,32.553,34.362,53.879,34.442c23.321,0.092,44.278-14.889,54.07-34.442\r\n\t\tC276.933,197.499,273.104,121.97,273.104,121.97z\"/>\r\n\t<path style=\"fill:#F0E8E4;\" d=\"M167.844,128.104c0.382,0.272,0.728,0.509,1.178,0.838c1.222,1.15-4.913,14.826-3.127,14.895\r\n\t\tc8.85,1.862,19.468-17.307,28.115-14.621c15.224,4.739,43.856,43.108,71.957,42.357c7.385-7.121,7.138-49.604,7.138-49.604\r\n\t\tc0-27.239-16.875-54.569-61.553-54.569c-37.018,0-54.458,20.535-59.365,43.068C159.097,113.422,164.882,119.134,167.844,128.104z\"\r\n\t\t/>\r\n\t<path style=\"fill:#F0E8E4;\" d=\"M230.563,232.011c-21.327-0.081-45.204-17.439-53.88-34.445\r\n\t\tc-8.674-17.009-8.535-91.077-8.535-92.508c0-9.471,2.017-19.238,6.453-27.981c-17.037,11.015-23.948,29.778-23.948,47.474\r\n\t\tc0,1.43-0.138,75.5,8.538,92.508c8.674,17.004,32.553,34.362,53.879,34.442c22.049,0.086,41.971-13.306,52.357-31.293\r\n\t\tC255.493,227.532,243.391,232.059,230.563,232.011z\"/>\r\n\t<g>\r\n\t\t<path style=\"fill:#F0E8E4;\" d=\"M265.126,220.657c0.092-0.155,0.21-0.294,0.301-0.449c-0.5,0.365-1.025,0.693-1.535,1.047\r\n\t\t\tC264.31,221.068,264.715,220.852,265.126,220.657z\"/>\r\n\t\t<path style=\"fill:#F0E8E4;\" d=\"M223.192,245.755c-21.324-0.08-45.205-17.436-53.878-34.445\r\n\t\t\tc-8.675-17.008-8.538-91.073-8.538-92.507c0-12.206,3.396-24.859,11.025-35.188c0.799-2.226,1.722-4.417,2.799-6.539\r\n\t\t\tc-17.037,11.015-23.948,29.778-23.948,47.474c0,1.43-0.138,75.5,8.538,92.508c8.674,17.004,32.553,34.362,53.879,34.442\r\n\t\t\tc12.096,0.049,23.479-4.054,33.073-10.653C239.013,243.984,231.25,245.789,223.192,245.755z\"/>\r\n\t</g>\r\n\t<path style=\"fill:#3D2216;\" d=\"M283.099,115.474c-5.498-29.987-29.987-51.729-70.029-51.48\r\n\t\tc-39.926,0.25-66.168,24.721-71.414,52.478c-2.249,11.888-3.986,34.487-3.062,47.957c6.759-5.558,9.546-6.281,12.819-4.978\r\n\t\tc2.239,24.494,7.568,24.126,7.568,24.126s0.491-16.634,1.578-27.626c1.089-10.989,19.082-12.986,28.078-31.991\r\n\t\tc28.49-1.239,46.48,35.247,77.718,37.245c-3.09,18.058,3.751,25.242,3.751,25.242s0.725-14.918,3.245-21.993\r\n\t\tc2.197-6.165,8.749-6.165,11.988-3.491C286.895,149.744,286.137,132.041,283.099,115.474z\"/>\r\n\t<g style=\"opacity:0.5;\">\r\n\t\t<path style=\"fill:#FFFFFF;\" d=\"M283.099,115.474c-5.498-29.987-29.987-51.729-70.029-51.48\r\n\t\t\tc-35.045,0.218-59.537,19.102-68.552,42.487c11.23-19.229,33.751-33.676,64.356-33.865c40.044-0.247,64.532,21.492,70.031,51.482\r\n\t\t\tc2.233,12.181,3.224,24.957,2.978,35.339c1.301,0.244,2.52,0.758,3.456,1.526C286.895,149.744,286.137,132.041,283.099,115.474z\"\r\n\t\t\t/>\r\n\t</g>\r\n\t<g>\r\n\t\t<path style=\"fill:#AFAAA8;\" d=\"M188.638,109.712c-8.996,19.007-37.985,36.917-50.044,40.469c-0.042-0.615-0.052-1.339-0.083-1.992\r\n\t\t\tc-0.221,5.941-0.232,11.635,0.083,16.24c6.759-5.558,9.546-6.281,12.819-4.978c2.239,24.494,7.568,24.126,7.568,24.126\r\n\t\t\ts0.491-16.634,1.578-27.626c1.089-10.989,19.082-12.986,28.078-31.991c28.366-1.235,46.339,34.911,77.329,37.193\r\n\t\t\tC243.109,153.218,217.128,108.475,188.638,109.712z\"/>\r\n\t</g>\r\n\t<path style=\"fill:#FFFFFF;\" d=\"M176.247,245.137l-4.855,13.797c0,0,14.473,27.251,27.041,31.781\r\n\t\tc3.837,1.385,11.834-16.329,14.622-16.329c1.345,0,12.141,18.794,13.781,18.418c12.874-2.936,27.637-33.629,27.637-33.629\r\n\t\tl-5.442-12.624l-35.976,22.643L176.247,245.137z\"/>\r\n</g>\r\n</svg>"

    /**
     * Given a string, capitalize the first letter of each word, unless the word is
     * surrounded by double quotes, in which case leave it as is.
     *
     * @param {string} str - Input string
     * @returns {string} Modified string with capitalized words
     */
    const capitalizeWords = (str) => {
        return str
            .split(/(\s+|".*?")/) // Split by spaces or quoted parts
            .map(segment => {
                // If the segment is a quoted part, return it as is
                if (segment.startsWith('"') && segment.endsWith('"')) {
                    return segment;
                }
                // If the segment is a regular word, capitalize it
                return segment
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
            })
            .join('');
    }


    /**
     * Given an HTML string, extracts the text content of the HTML and returns it,
     * with whitespace trimmed.
     *
     * @param {string} html - Input HTML string
     * @returns {string} Text content of the HTML
     */
    const getTextFromHTML = (html) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        return tempElement.textContent.trim();
    };


    /**
     * Creates a section for the professional summary in the PDF document.
     *
     * @param {string} summary - The professional summary text.
     * @returns {object} A section object to be used with the pdfMake library.
     */
    const summarySection = (summary) => {
        return !summary ? null : {
            stack: [
                { text: 'PROFESSIONAL SUMMARY', style: 'sectionHeader', margin: [0, 7, 0, 1] },
                { text: summary, style: 'tableCell', margin: [0, 0, 0, 3] },
            ]
        };
    };

    /**
     * Creates a section for the education in the PDF document.
     *
     * @param {array} educations - The education history of the user.
     * @returns {object} A section object to be used with the pdfMake library.
     */
    const educationSection = (educations) => {
        if (!educations?.length) return null;
        educations = educations?.filter(education => education?._id);
        return {
            stack: [
                { text: 'EDUCATION', style: 'sectionHeader', margin: [0, 7, 0, 0] },
                {
                    margin: [0, 2, 0, 5],
                    unbreakable: true,
                    table: {
                        headerRows: 1,
                        widths: ['*', 80],
                        body: educations?.map(education => {
                            return [
                                {
                                    stack: [
                                        {
                                            text: [{ text: `${education?.degree_received} ${education?.field_of_study ? "(" + education?.field_of_study + ")" : ""}`, style: 'tableCell', bold: true }, { text: `${education?.education_institute_name ? ", " + allCapitalize(education?.education_institute_name) : ""}`, style: 'tableCell' }]
                                        },
                                        education?.key_accomplishments?.length ? {
                                            margin: [10, 5, 0, 0],
                                            style: 'tableCell',
                                            lineHeight: 1.3,
                                            ul: education?.key_accomplishments?.map((accomplishment) => [accomplishment])
                                        } : null
                                    ],
                                    border: [1, 1, 0, 1]
                                },
                                { text: `${education?.education_from ? dayjs(education?.education_from).format("MMM YY") + "’ - " : ""}${education?.education_to ? dayjs(education?.education_to).format("MMM YY") + "’" : "Present"}`, style: 'tableCell', alignment: "right", border: [0, 1, 1, 1] },
                            ]
                        })
                    },
                    layout: {
                        hLineColor: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? '#e6ebfe' : '#e6ebfd';
                        },
                        vLineColor: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? '#e6ebfe' : '#e6ebfd';
                        },
                        paddingLeft: function () { return 5; },
                        paddingRight: function () { return 5; },
                        paddingTop: function () { return 2; },
                        paddingBottom: function () { return 2; }
                    }
                }
            ]
        }
    };

    /**
     * Generates a certification section for a candidate's resume.
     * @param {array} certifications - certifications array
     * @returns {object} - certification section object
     */
    const certificationSection = (certifications) => {
        if (!certifications?.length) return null;
        certifications = certifications?.filter(certification => certification?._id);
        return {
            stack: [
                { text: 'CERTIFICATIONS', style: 'sectionHeader', margin: [0, 7, 0, 0] },
                {
                    margin: [0, 2, 0, 5],
                    unbreakable: true,
                    table: {
                        headerRows: 1,
                        dontBreakRows: true,
                        widths: ['*', 80],
                        body: certifications?.map(certification => {
                            return [
                                {
                                    stack: [
                                        {
                                            text: [{ text: `${certification?.certificate_received} ${certification?.field_of_study ? "(" + certification?.field_of_study + ")" : ""}`, style: 'tableCell', bold: true }, { text: `${certification?.education_institute_name ? ", " + allCapitalize(certification?.education_institute_name) : ""}`, style: 'tableCell' }]
                                        }
                                    ],
                                    border: [1, 1, 0, 1]
                                },
                                { text: `${certification?.education_from ? dayjs(certification?.education_from).format("MMM YY") + "’ - " : ""}${certification?.education_to ? dayjs(certification?.education_to).format("MMM YY") + "’" : "Present"}`, style: 'tableCell', alignment: "right", border: [0, 1, 1, 1] },
                            ]
                        })
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 1 : 0;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                        },
                        hLineColor: '#e6ebfe',
                        vLineColor: '#e6ebfe',
                        paddingLeft: function () { return 5; },
                        paddingRight: function () { return 5; },
                        paddingTop: function () { return 2; },
                        paddingBottom: function () { return 2; }
                    }
                }
            ]
        }
    };

    /**
     * Generates a work experience section for a resume PDF.
     * @param {Array} workHistory - Array of work experience data.
     * @returns {Object} - Object containing the PDFMake definition for the work experience section.
     */
    const workExperienceSection = (workHistory) => {
        if (!workHistory?.length) return null;
        const workGaps = workHistory?.filter(wh => wh.organization_name?.toLowerCase() === "work gap" && !wh.show_in_resume);
        const filteredWorkHistory = workHistory?.filter(
            wh => !(wh.organization_name?.toLowerCase() === "work gap" && !wh.show_in_resume)
        );

        workHistory = filteredWorkHistory.map(wHistory => {
            const fromDate = wHistory?.work_history_from ? dayjs(wHistory.work_history_from) : dayjs(new Date());
            const toDate = wHistory?.work_history_to ? dayjs(wHistory.work_history_to) : dayjs(new Date());
            const exprInMonths = toDate.diff(fromDate, 'month');
            return {
                ...wHistory,
                organization_name: wHistory?.organization_name === 'Work Gap' ? `Career Break: ${wHistory?.gap_title}` : allCapitalize(wHistory?.organization_name || ''),
                industry_sector: changeNameFormat(wHistory?.organization_details?.industry_sector || ' '),
                experience: (exprInMonths / 12).toFixed(1),
                highest_designation: wHistory?.organization_name === 'Work Gap' ? ' ' : wHistory?.highest_designation,
                col_span: wHistory?.organization_name === 'Work Gap' ? 4 : 1,
                team_size_managed: wHistory?.organization_name === 'Work Gap' ? ' ' : wHistory?.team_size_managed === 'Individual contributor (IC)' ? 'IC' : wHistory?.team_size_managed
            }
        });
        return {
            stack: [
                { text: 'WORK EXPERIENCE OVERVIEW', style: 'sectionHeader', margin: [0, 7, 0, 0] },
                {
                    margin: [0, 2, 0, 5],
                    table: {
                        headerRows: 1,
                        dontBreakRows: true,
                        widths: [78, '*', 100, 110, 30],
                        body: [
                            [
                                { text: 'Period', style: 'tableHeader' },
                                { text: 'Company Name', style: 'tableHeader' },
                                { text: 'Industry', style: 'tableHeader' },
                                { text: 'Last Designation', style: 'tableHeader' },
                                { text: 'Team', style: 'tableHeader' }
                            ],
                            ...(workHistory?.map((workExperience) => [
                                { text: `${workExperience?.work_history_from ? dayjs(workExperience?.work_history_from).format("MMM YY") + "’ - " : ""}${workExperience?.work_history_to ? dayjs(workExperience?.work_history_to).format("MMM YY") + "’" : (workExperience?.present ? "Present" : "")}`, style: 'smallTableCell' },
                                { text: `${allCapitalize(truncateTextToTwoLines(workExperience?.organization_name, 55))}`, style: 'smallTableCell', colSpan: workExperience?.col_span },
                                { text: `${truncateTextToTwoLines(workExperience?.industry_sector, 45)}`, style: 'smallTableCell' },
                                { text: `${truncateTextToTwoLines(workExperience?.highest_designation, 60)}`, style: 'smallTableCell' },
                                { text: `${workExperience?.team_size_managed || ""}`, style: 'smallTableCell' }
                            ]))
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 1 : 0;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                        },
                        fillColor: function (rowIndex) {
                            return (rowIndex % 2) === 0 ? '#e6ebfe' : null;
                        },
                        hLineColor: '#e6ebfe',
                        vLineColor: '#e6ebfe',
                        paddingLeft: function () { return 5; },
                        paddingRight: function () { return 5; },
                        paddingTop: function () { return 2; },
                        paddingBottom: function () { return 2; }
                    }
                },
            ]
        }
    };

    /**
     * Returns a PDFMake definition that displays key responsibilities and accomplishments in a tabular format.
     * If there is no valid work history, returns null.
     * @param {Array<Object>} work - The work history of the candidate. Each element in the array
     * should have an "organization_name" key that is not equal to "Work Gap".
     * @returns {Object | null} A PDFMake definition or null if there is no valid work history.
     */
    const keyResponsibilitiesSection = (workHistory) => {
        if (!workHistory?.length) return null;
        workHistory = workHistory?.filter(
            wh => wh.organization_name?.toLowerCase() !== "work gap"
        );

        const groupedHistory = [];
        let currentGroup = null;

        for (const record of workHistory) {
            const role = {
                job_type: record?.job_type,
                work_history_from: record?.work_history_from ? dayjs(record?.work_history_from).format("MMM YY") : "",
                work_history_to: record?.work_history_to ? dayjs(record?.work_history_to).format("MMM YY") : "",
                present: record?.present,
                gap_title: record?.gap_title || "",
                team_size_managed: record?.team_size_managed,
                work_history_location: record?.work_history_location,
                last_job_function: record?.last_job_function,
                highest_designation: record?.highest_designation,
                work_oriented_skills: record?.work_oriented_skills || [],
                key_accomplishments: record?.key_accomplishments || [],
            };
            if (
                currentGroup &&
                currentGroup?.organization_name?.toLowerCase() === record.organization_name?.toLowerCase()
            ) {
               const existingWorkIdex = [...groupedHistory]?.reverse()?.findIndex(wHistory => wHistory?.organization_name?.toLowerCase() === record.organization_name?.toLowerCase());
                const correctedIndex = existingWorkIdex !== -1 ? groupedHistory?.length - 1 - existingWorkIdex : -1;

                groupedHistory[correctedIndex].roles.push(role);
            } else {
                currentGroup = {
                    organization_name: record.organization_name
                };
                groupedHistory.push({
                    organization_name: allCapitalize(record?.organization_name || ''),
                    industry_sector: changeNameFormat(record?.organization_details?.industry_sector || ''),
                    roles: [role]
                });
            }
        }
        return {
            stack: [
                { text: 'KEY RESPONSIBILITIES AND ACCOMPLISHMENTS', style: 'sectionHeader', margin: [0, 3, 0, 0] },
                {
                    margin: [0, 2, 0, 5],
                    table: {
                        dontBreakRows: true,
                        widths: ['100%'],
                        body: [
                            ...(groupedHistory?.map((workExperience) => [
                                {
                                    stack: [
                                        { text: [{ text: `${allCapitalize(workExperience?.organization_name)} `, bold: true }, `${workExperience?.industry_sector || ""}`], style: 'tableCell', margin: [0, 0, 0, 1.5] },
                                        {
                                            margin: [0, 0, 0, 0],
                                            stack: workExperience?.roles?.map((role, rIndex) => {
                                                return {
                                                    unbreakable: rIndex < 1 ? true : false,
                                                    stack: [

                                                        {
                                                            columns: [
                                                                {
                                                                    text: [{ text: `${role?.highest_designation}`, bold: true }, ' ', `${role?.work_history_location ? "(" + role?.work_history_location + ")" : ""}`]
                                                                },
                                                                {
                                                                    text: `${role?.work_history_from ? role?.work_history_from + "’ - " : ""}${role?.work_history_to ? role?.work_history_to + "’" : "Present"}`, alignment: 'right'
                                                                }
                                                            ]
                                                        },
                                                        role?.key_accomplishments?.length ? {
                                                            margin: [10, 0, 0, 0],
                                                            style: 'tableCell',
                                                            // lineHeight: 1.15,
                                                            ul: [
                                                                ...(role?.key_accomplishments?.map((accomplishment, wrIndex) => {
                                                                    return { text: `${accomplishment}`, unbreakable: wrIndex < 1 ? false : true }
                                                                }))
                                                            ]
                                                        } : null
                                                    ]
                                                }
                                            })
                                        }
                                    ]
                                }
                            ]))
                        ]
                    },
                    layout: {
                        hLineColor: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? '#e6ebfe' : '#f5f8ff';
                        },
                        vLineColor: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? '#e6ebfe' : '#f5f8ff';
                        },
                        paddingLeft: function () { return 5; },
                        paddingRight: function () { return 5; },
                        paddingTop: function () { return 2; },
                        paddingBottom: function () { return 2; },
                    }
                },
            ]
        }
    };

    const truncateTextToTwoLines = (text, maxLength) => {
        if (typeof text !== 'string' || !text) return '';

        if (maxLength <= 3) {
            if (text.length > maxLength) {
                return text.substring(0, Math.max(0, maxLength - 1)) + (maxLength > 0 ? "." : "");
            }
            return text;
        }

        if (text.length <= maxLength) {
            return text;
        }

        let effectiveMaxLength = maxLength;

        const scanLength = Math.min(text.length, Math.floor(maxLength * 1.5));
        const textPortionForScan = text.substring(0, scanLength);
        const words = textPortionForScan.split(' ');
        const approxCharsPerLine = maxLength / 2.0;
        let containsProblematicLongWord = false;

        for (const word of words) {
            if (word.length > approxCharsPerLine * 1.3) {
                containsProblematicLongWord = true;
                break;
            }
        }

        if (containsProblematicLongWord) {
            effectiveMaxLength = Math.max(4, Math.floor(maxLength * 0.90));
        }

        const pointOfTruncation = effectiveMaxLength - 3;

        if (pointOfTruncation < 0) {
            if (effectiveMaxLength > 0) {
                return text.substring(0, Math.max(0, effectiveMaxLength - 1)) + ".";
            }
            return "";
        }

        let baseTruncatedText = text.substring(0, pointOfTruncation);
        const lastSpaceIndex = baseTruncatedText.lastIndexOf(' ');

        if (lastSpaceIndex > 0 && lastSpaceIndex > baseTruncatedText.length / 2) {
            return text.substring(0, lastSpaceIndex) + "...";
        } else {
            return baseTruncatedText + "...";
        }
    };

    /**
     * Returns a pdfMake document definition for the skills section of a resume.
     *
     * It will only return a non-null value if there are skills to display.
     *
     * @return {Object|null} A pdfMake document definition or null if there are no skills to display.
     */

    const skillsSections = () => {
        const sortedHistory = workExperienceData?.filter(wh => wh?._id && wh?.organization_name?.toLowerCase() !== "work gap"); //?.sort((a, b) => new Date(a.work_history_from) - new Date(b.work_history_from));

        let skills = groupWorkSkills(sortedHistory);

        if (!skills?.length) return null;
        return {
            unbreakable: skills?.length > 1 ? false : true,
            stack: [
                { text: 'Skills Summary'.toUpperCase(), style: 'sectionHeader', margin: [0, 7, 0, 0] },
                {
                    margin: [0, 2, 0, 5],
                    table: {
                        dontBreakRows: true,
                        widths: [85, '*', 130, 48],
                        body: [
                            [
                                { text: 'Expertise', style: 'tableHeader' },
                                { text: 'Key Skills', style: 'tableHeader' },
                                { text: 'Where learned / used?', style: 'tableHeader' },
                                { text: 'Experience', style: 'tableHeader' }
                            ],
                            ...(skills?.map(skill => [
                                { text: `${skill?.expertise}`, style: 'smallTableCell', unbreakable: true },
                                { text: `${skill?.key_skills}`, style: 'smallTableCell', unbreakable: true },
                                { text: `${capitalizeWords(skill?.where_learned)}`, style: 'smallTableCell', unbreakable: true },
                                { text: `${skill?.experience < 2 ? skill?.experience + " year" : skill?.experience + " years"}`, style: 'smallTableCell', unbreakable: true }
                            ]))
                        ]
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                        },
                        fillColor: function (rowIndex) {
                            return (rowIndex % 2) === 0 ? '#f0f3fe' : null;
                        },
                        hLineColor: '#e6ebfe',
                        vLineColor: '#e6ebfe',
                        paddingLeft: function () { return 5; },
                        paddingRight: function () { return 5; },
                        paddingTop: function () { return 2; },
                        paddingBottom: function () { return 2; }
                    }
                },
            ]
        }
    };

    /**
     * This function groups the work history entries by last_job_function and then
     * aggregates the organization_name, skills and experience for each group.
     * The organization_name is capitalized and the skills are unique.
     * The experience is calculated using the calculateExperience function.
     * The result is an array of objects with the properties expertise, key_skills, where_learned and experience.
     * @param {Array} workHistories - An array of work history entries.
     * @returns {Array} An array of objects with the properties expertise, key_skills, where_learned and experience.
     */
    const groupWorkSkills = (workHistories) => {
        // Grouping and aggregating data using find
        const groupedData = [];

        workHistories.forEach(({ last_job_function, organization_name, skills, work_history_from, work_history_to }) => {
            if (!skills?.length) return;
            // Find the existing group for this role
            let group = groupedData.find(g => g.last_job_function === last_job_function);

            if (!group) {
                // If no group exists, create a new one
                group = { last_job_function, organization_name: new Set(), skills: new Set(), experience: 0 };
                groupedData.push(group);
            }

            // Add unique companies
            group.organization_name.add(allCapitalize(organization_name || ""));

            // Add unique skills
            skills.forEach(skill => group.skills.add(skill));

            // Add experience
            group.experience += calculateExperience(work_history_from, work_history_to);
        });

        return groupedData?.map(wh => {
            return {
                expertise: wh?.last_job_function,
                key_skills: Array.from(wh?.skills?.values() || [])?.join(', '),
                where_learned: Array.from(wh?.organization_name?.values() || []).join(', '),
                experience: wh?.experience
            };
        });
    };

    // Helper function to calculate experience in years
    const calculateExperience = (start, end) => {
        const fromDate = start ? dayjs(start) : dayjs(new Date());
        const toDate = end ? dayjs(end) : dayjs(new Date());

        // Calculate the difference in months
        const experience = (toDate.diff(fromDate, 'month') / 12).toFixed(0);
        return parseInt(experience, 10);
    };

    /**
     * This function takes an array of custom sections and returns a pdfmake document
     * definition for the sections. The sections are filtered to only include those
     * with a key and a message. The message is converted to pdfmake format using
     * the htmlToPdfmake function. The key is uppercased and used as the heading for
     * the section. The section is then wrapped in an unbreakable stack to prevent
     * page breaks within the section.
     * @param {Array} sections - An array of custom section objects with key and message properties.
     * @returns {Object} A pdfmake document definition for the sections.
     */
    const customSections = (sections) => {
        if (!sections?.length) return null;
        const filteredSections = sections?.filter(section => getTextFromHTML(section?.message) && section?.key);
        return filteredSections?.map((section) => {
            const messageContent = htmlToPdfmake(section?.message);
            return {
                stack: [
                    {
                        unbreakable: true,
                        stack: [
                            { text: (section?.key || '').toUpperCase(), style: 'sectionHeader', margin: [0, 7, 0, 0] },
                            messageContent
                        ]
                    }
                ]
            };
        })
    };

    /**
     * Generates a PDF section for technical competencies.
     * @param {Array} techs - An array of technical competencies.
     * @returns {Object|null} A pdfmake document definition for the technical competencies section,
     * or null if no competencies are provided.
     */

    const techCompetencySection = (techs) => {
        if (!techs?.length) return null;
        return {
            unbreakable: true,
            stack: [
                { text: 'Technical Competencies'.toUpperCase(), style: 'sectionHeader', margin: [0, 7, 0, 5] },
                ...createChipsLayout(techs)
            ]
        }
    };

    // Helper function to create dynamically wrapped rows of chips
    function createChipsLayout(skills) {
        const pageWidth = 592;
        const row = [];
        const rows = [];
        let currentRowWidth = 0;

        skills.forEach((skill) => {
            const chipWidth = skill.length * 6 + 22;
            if (currentRowWidth + chipWidth > pageWidth) {
                rows.push({ columns: row.slice(), columnGap: 2 });
                row.length = 0;
                currentRowWidth = 0;
            }

            row.push({
                width: 'auto',
                margin: [0, 0, 3, 5],
                table: {
                    headerRows: 1,
                    widths: ['auto'],
                    body: [
                        [
                            { text: skill, style: 'chip' },
                        ]
                    ]
                },
                layout: {
                    hLineColor: '#e6ebfe',
                    vLineColor: '#e6ebfe',
                    paddingLeft: function () { return 8; },
                    paddingRight: function () { return 8; },
                    paddingTop: function () { return 5; },
                    paddingBottom: function () { return 5; }
                }
            });
            currentRowWidth += chipWidth;
        });

        // Add the last row
        if (row.length > 0) {
            rows.push({ columns: row, columnGap: 5 });
        }

        return rows;
    };

    const preloadedImages = (profile?.photo || profile?.profile_pic) ? await preloadImages([profile?.photo || profile?.profile_pic]) : null;
    const base64Images = preloadedImages?.length ? convertImagesToBase64(preloadedImages) : [];

    const docDefinition = {
        pageMargins: [20, 40, 20, 25],
        footer: function (currentPage, pageCount) {
            return {
                margin: [20, 0, 15, 20],
                columns: [
                    {
                        text: `${profile?.name}`, fontSize: 8
                    },
                    {
                        text: `Page ${currentPage}/${pageCount}`, alignment: 'right', fontSize: 8
                    }
                ]
            }
        },
        content: [
            {
                columns: [
                    {
                        ... { [base64Images?.length ? 'image' : 'svg']: (base64Images?.length ? base64Images[0] : image64) }, // Add base64 image
                        width: 40,
                        height: 40,
                        alignment: 'left'
                    },
                    [
                        {
                            margin: [10, 5, 0, 0],
                            stack: [
                                { text: `${profile?.name}`, style: 'header' },
                                { text: `${profile?.email ? profile?.email + " | " : ""}${profile?.phone ? "+91-" + profile?.phone + " | " : ""}${profile?.city ? profile?.city : ""}`, style: 'subheader' }
                            ]
                        }
                    ]
                ]
            },
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0, y1: 0,
                        x2: (595 - 40), y2: 0, // The width of the line
                        lineWidth: 1,
                        lineColor: '#e6ebfe' // Match the line color with the table color
                    }
                ],
                margin: [0, 5, 0, 5]
            },
            summarySection(summaryData),
            educationSection(educationData),
            certificationSection(certificateData),
            workExperienceSection(workExperienceData),
            keyResponsibilitiesSection(workExperienceData),
            customSections(customSection),
            skillsSections(),
            techCompetencySection(financeTechologiesData)
        ],
        styles: {
            header: {
                fontSize: 12,
                bold: true,
                lineHeight: 1.3,
                color: '#111827'
            },
            subheader: {
                margin: [0, 0, 0, 10],
                color: '#002149'
            },
            sectionHeader: {
                bold: true,
                margin: [0, 10, 0, 5],
                color: '#111827'
            },
            tableHeader: {
                bold: true,
                color: '#111827'
            },
            tableCell: {
                color: '#002149'
            },
            smallTableCell: {
                color: '#002149',
                fontSize: 9
            },
            boldText: {
                bold: true,
                color: '#111827'
            },
            listItem: {
                margin: [0, 5, 0, 5],
                lineHeight: 1.1
            },
            chip: {
                bold: true,
                fillColor: '#f9faff'
            }
        },
        defaultStyle: {
            fontSize: 10,
            lineHeight: 1,
            color: '#002149',
            font: 'Times New Roman'
        }
    };

    return new Promise((resolve, reject) => {
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.getBuffer((buffer) => {
            if (buffer) {
                resolve(buffer);
            } else {
                reject(new Error('Failed to generate PDF buffer'));
            }
        });
    });
}